import { useState } from 'react';
import { Calendar } from 'react-feather';
import moment from 'moment';
import DatePicker from 'components/DatePicker';
import TableInvoice from './TableInvoice';

const DATE_FORMAT = 'YYYY-MM-DDTHH:mm';

const InvoiceMain = () => {
    const [params, setParams] = useState({
        search: '',
        from: moment().add(-30, 'days').format(DATE_FORMAT),
        to: moment().format(DATE_FORMAT),
    });

    const handleDate = (date, name) => {
        setParams({ ...params, [name]: moment(date).format(DATE_FORMAT) });
    };

    return (
        <div className="pt-5 mx-5">
            <div className="d-flex align-items-center pb-4">
                <h2 className="title-h3">Billing and invoicing</h2>
                <div className="ms-4 position-relative">
                    <Calendar size={16} className="input-icon" />
                    <DatePicker
                        value={params.from}
                        onChange={(date) => handleDate(date, 'from')}
                        maxDate={new Date()}
                    />
                </div>
                <div className="ms-3 position-relative">
                    <Calendar size={16} className="input-icon" />
                    <DatePicker
                        value={params.to}
                        onChange={(date) => handleDate(date, 'to')}
                        minDate={params.from}
                        maxDate={new Date()}
                    />
                </div>
            </div>
            <TableInvoice />
        </div>
    );
};

export default InvoiceMain;
